import { render, staticRenderFns } from "./InstructionEdit.vue?vue&type=template&id=578a9018&scoped=true&"
import script from "./InstructionEdit.vue?vue&type=script&lang=js&"
export * from "./InstructionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a9018",
  null
  
)

export default component.exports